import { AbstractAvailableWinDisplayProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractAvailableWinDisplayProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import * as PIXI from "pixi.js";
import { GameLang } from "../lang/GameLang";
import { GameFontStyle } from "../style/GameFontStyle";
/**
 * AvailableWinDisplayProperties.ts
 */
export class AvailableWinDisplayProperties extends AbstractAvailableWinDisplayProperties {
    constructor() {
        super();
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, false);
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            (!this.availableWinProperties || this.availableWinProperties.equals(other.availableWinProperties)) &&
            this.availableWinTextHolderPosition.equals(other.availableWinTextHolderPosition) &&
            this.availableWinTextHolderScale.equals(other.availableWinTextHolderScale) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.labelOnTheNextSpinProperties.equals(other.labelOnTheNextSpinProperties) &&
            this.labelYouCouldWinProperties.equals(other.labelYouCouldWinProperties) &&
            this.mouseBlockerProperties.equals(other.mouseBlockerProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.availableWinTextHolderFilters = [];
        this.availableWinTextHolderPosition = new PIXI.Point(1218, 410);
        this.availableWinTextHolderScale = new PIXI.Point(1, 1);
        this.backgroundProperties = new SpriteProperties(CommonStyle.MESSAGE_DIALOG_0, CommonStyle.MODULE, new PIXI.Point(0, 15), new PIXI.Point(0.85, 0.85), new PIXI.Point(0.5, 0.5));
        this.labelOnTheNextSpinProperties = new TextFieldProperties(GameFontStyle.AVAILABLE_WIN_LABEL_MEDIUM, new PIXI.Point(-10, -200), GameLang.AVAILABLE_WIN_LABEL0, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(610, 90));
        this.labelYouCouldWinProperties = new TextFieldProperties(GameFontStyle.AVAILABLE_WIN_LABEL_MEDIUM, new PIXI.Point(-10, -100), GameLang.AVAILABLE_WIN_LABEL2, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(610, 90));
        this.availableWinFieldProperties = new TextFieldProperties(GameFontStyle.AVAILABLE_WIN_LABEL_MEDIUM, new PIXI.Point(-10, 0), null, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(610, 90));
    }
}
//# sourceMappingURL=AvailableWinDisplayProperties.js.map